module.exports = __webpack_public_path__ + "assets/spanorm.871325a6.svg";